/**
 * droneTelemetryClock
 * ------------------------------------------------------------
 * 마지막 드론 텔레메트리(WS 프레임) 수신 시각.
 *
 * REST /info 의 하트비트 판정은 폴링 주기(5초)만큼 낡을 수 있어서,
 * "서버는 끊김이라는데 방금 WS 프레임이 왔다"는 순간의 깜빡임을 막기 위해
 * FlightNote 가 이 시각으로 최신 신호 우선 규칙을 적용한다.
 *
 * ref 성격의 모듈 변수라 기록해도 리렌더를 유발하지 않는다 — 소비처는
 * 자신이 다른 이유(droneData 갱신 등)로 렌더될 때 읽기만 한다.
 */
let lastTelemetryAt = 0;

export const markDroneTelemetry = () => {
  lastTelemetryAt = Date.now();
};

// 드론 전환/소켓 해제 시 이전 드론의 수신 기록이 새 드론의 판정에 쓰이지 않게 초기화
export const resetDroneTelemetryClock = () => {
  lastTelemetryAt = 0;
};

export const msSinceDroneTelemetry = () =>
  lastTelemetryAt ? Date.now() - lastTelemetryAt : Infinity;
